module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-top.e1f10611.svg";